import Icon from "@ant-design/icons";

const Component = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.2em"
    height="1.2em"
    fill="currentColor"
    viewBox="0 0 485.629 485.629"
  >
    <g>
      <path d="M480.1,264.564c-4.8-3.9-8.1-5.9-11.1-5.9c-3.4,0-6.4,2.6-11,7.9
      c-23.2,26.9-46.4,53.7-69.6,80.6c-5.2,6-10.4,12-15.8,18.2c-2.7-2.1-5.2-4-7.7-6
      c-13.7-10.6-27.2-21.3-41-31.6c-3.1-2.3-5.7-3.5-8.1-3.5c-3,0-5.8,1.8-9.2,5.3
      c-1,1-1.8,2-2.7,3.1c-2.5,3-2.9,6.2-0.8,9.5c2.5,3.9,5,7.9,7.8,11.6
      c18.3,23.8,36.6,47.5,55,71.3c2.2,2.9,4.8,4.4,7.4,4.4c2.8,0,5.6-1.7,8-5.2
      c33.7-48.2,67.3-96.3,100.9-144.5C487.3,272.464,486.8,270.064,480.1,264.564z"/>
      <path d="M265.3,324.164c-9,10.9-20.7,18.3-34.4,22
      c-6,1.6-8.6,4.8-8.3,11c0.3,6.1,0,12.2,0,18.3c0,5.4-2.8,8.3-8.1,8.5
      c-6.5,0.2-13.1,0.2-19.7,0c-5.7-0.1-8.4-3.4-8.5-9c-0.1-4.4-0.1-8.9-0.1-13.3
      c-0.1-9.8-0.4-10.2-9.9-11.7c-12.1-1.9-23.9-4.7-35-10c-8.7-4.2-9.6-6.4-7.1-15.5
      c1.9-6.8,3.7-13.6,5.8-20.3c2.4-7.8,4.5-8.8,11.7-5c12.2,6.4,25.2,9.9,38.8,11.6
      c8.8,1.1,17.3,0.2,25.5-3.3c15.1-6.6,17.5-24.2,4.7-34.7c-4.4-3.6-9.3-6.2-14.5-8.5
      c-13.3-5.8-27.1-10.3-39.7-17.8c-20.4-12.2-33.3-28.9-31.8-53.7c1.7-28,17.5-45.5,43.2-54.8
      c10.6-3.9,10.6-3.7,10.7-14.8c0-3.7,0-7.5,0-11.2c0.2-8.4,1.6-9.8,9.9-10
      c2.6-0.1,5.2,0,7.7,0c17.7,0,17.7,0,17.8,17.7c0.1,12.5,0,12.6,12.5,14.5
      c9.6,1.5,18.7,4.3,27.5,8.2c4.9,2.1,6.7,5.6,5.2,10.7c-2.2,7.6-4.3,15.3-6.7,22.9
      c-2.3,7.2-4.6,8.2-11.5,4.9c-13.8-6.7-28.3-9.5-43.6-8.6c-4,0.2-7.9,0.8-11.6,2.4
      c-13.2,5.8-15.3,20.3-4.1,29.3c5.7,4.5,12.2,7.8,18.9,10.6c11.7,4.8,23.4,9.5,34.5,15.6
      C280.6,249.564,290.2,293.864,265.3,324.164z"/>
    </g>
  </svg>


);

export const PaymentAcceptedIcon = (props) => <Icon component={Component} {...props} />;
